export default "__VITE_ASSET__G56rdFVt__"